__turbopack_context__.v({
  "container": "FileInput-module__-FP9WG__container",
  "disabled": "FileInput-module__-FP9WG__disabled",
  "dropzone": "FileInput-module__-FP9WG__dropzone",
  "fileName": "FileInput-module__-FP9WG__fileName",
  "hint": "FileInput-module__-FP9WG__hint",
  "icon": "FileInput-module__-FP9WG__icon",
  "nativeInput": "FileInput-module__-FP9WG__nativeInput",
  "text": "FileInput-module__-FP9WG__text",
});
